export default [
  {
    symbol: 'ETH',
    address: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
    swapGasLimit: 0,
    approveGasLimit: 0
  },
  {
    symbol: 'WETH',
    address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'KNC',
    address: '0xdd974d5c2e2928dea5f71b9825b8b646686bd200',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'DAI',
    address: '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359',
    swapGasLimit: 500000,
    approveGasLimit: 100000
  },
  {
    symbol: 'OMG',
    address: '0xd26114cd6ee289accf82350c8d8487fedb8a0c07',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'SNT',
    address: '0x744d70fdbe2ba4cf95131626614a1763df805b9e',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ELF',
    address: '0xbf2179859fc6d5bee9bf9158632dc51678a4100e',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'POWR',
    address: '0x595832f8fc6bf59c85c527fec3740a1b7a361269',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'MANA',
    address: '0x0f5d2fb29fb7d3cfee444a200298f468908cc942',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'BAT',
    address: '0x0d8775f648430679a709e98d2b0cb6250d2887ef',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'REQ',
    address: '0x8f8221afbb33998d8584a2b05749ba73c37a938a',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'GTO',
    address: '0xc5bbae50781be1669306b9e001eff57a2957b09d',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'RDN',
    address: '0x255aa6df07540cb5d3d297f0d0d4d84cb52bc8e6',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'APPC',
    address: '0x1a7a8bd9106f2b8d977e08582dc7d24c723ab0db',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ENG',
    address: '0xf0ee6b27b759c9893ce4f094b49ad28fd15a23e4',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'BQX',
    address: '0x5af2be193a6abca9c8817001f45744777db30756',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ADX',
    address: '0x4470bb87d77b963a013db939be332f927f2b992e',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'AST',
    address: '0x27054b13b1b798b345b591a4d22e6562d47ea75a',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'RCN',
    address: '0xf970b8e36e23f7fc3fd752eea86f8be8d83375a6',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ZIL',
    address: '0x05f4a42e251f2d52b8ed15e9fedaacfcef1fad27',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'LINK',
    address: '0x514910771af9ca656af840dff83e8264ecf986ca',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'DGX',
    address: '0x4f3afec4e5a3f2a6a1a411def7d7dfe50ee057bf',
    swapGasLimit: 750000,
    approveGasLimit: 120000
  },
  {
    symbol: 'STORM',
    address: '0xd0a4b8946cb52f0661273bfbc6fd0e0c75fc6433',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'IOST',
    address: '0xfa1a856cfa3409cfa145fa4e20eb270df3eb21ab',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'MOT',
    address: '0x263c618480dbe35c300d8d5ecda19bbb986acaed',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ABT',
    address: '0xb98d4c97425d9908e66e53a6fdf673acca0be986',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ENJ',
    address: '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'AE',
    address: '0x5ca9a71b1d01849c0a95490cc00559717fcf0d1d',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'BLZ',
    address: '0x5732046a883704404f284ce41ffadd5b007fd668',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ELEC',
    address: '0xd49ff13661451313ca1553fd6954bd1d9b6e02b9',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'BBO',
    address: '0x84f7c44b6fed1080f647e354d552595be2cc602f',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'POLY',
    address: '0x9992ec3cf6a55b00978cddf2b27bc6882d88d1ec',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'LBA',
    address: '0xfe5f141bf94fe84bc28ded0ab966c16b17490657',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'CVC',
    address: '0x41e5560054824ea6b0732e656e3ad64e20e94e45',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'WAX',
    address: '0x39bb259f66e1c59d5abef88375979b4d20d98022',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'POE',
    address: '0x0e0989b1f9b8a38983c2ba8053269ca62ec9b195',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'PAY',
    address: '0xb97048628db6b661d4c2aa833e95dbe1a905b280',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'DTA',
    address: '0x69b148395ce0015c13e36bffbad63f49ef874e03',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'BNT',
    address: '0x1f573d6fb3f13d689ff844b4ce37794d79a7ff1c',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'TUSD',
    address: '0x8dd5fbce2f6a956c3022ba3663759011dd51e73e',
    swapGasLimit: 550000,
    approveGasLimit: 100000
  },
  {
    symbol: 'LEND',
    address: '0x80fb784b7ed66730e8b1dbd9820afd29931aab03',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'WINGS',
    address: '0x667088b212ce3d06a1b553a7221e1fd19000d9af',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'MTL',
    address: '0xf433089366899d83a9f26a773d59ec7ecf30355e',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'WABI',
    address: '0x286bda1413a2df81731d4930ce2f862a35a609fe',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'COFI',
    address: '0x3136ef851592acf49ca4c825131e364170fa32b3',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'MOC',
    address: '0x865ec58b06bf6305b886793aa20a2da31d034e68',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'BNB',
    address: '0xb8c77482e45f1f44de1745f52c74426c631bdd52',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'REP',
    address: '0x1985365e9f78359a9b6ad760e32412f4a445e862',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ZRX',
    address: '0xe41d2489571d322189246dafa5ebde1f4699f498',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'MAS',
    address: '0x23ccc43365d9dd3882eab88f43d515208f832430',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'DAT',
    address: '0x81c9151de0c8bafcd325a57e3db5a5df1cebf79c',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'REN',
    address: '0x408e41876cccdc0f92210600ef50372656052a38',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'QKC',
    address: '0xea26c4ac16d4a5a106820bc8aee85fd0b7b2b664',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'MKR',
    address: '0x9f8f72aa9304c8b593d555f12ef6589cc3a579a2',
    swapGasLimit: 400000,
    approveGasLimit: 100000
  },
  {
    symbol: 'DCC',
    address: '0xffa93aacf49297d51e211817452839052fdfb961',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'SSP',
    address: '0x624d520bab2e4ad83935fa503fb130614374e850',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'PRO',
    address: '0x226bb599a12c826476e3a771454697ea52e9e220',
    swapGasLimit: 500000,
    approveGasLimit: 300000
  },
  {
    symbol: 'OCN',
    address: '0x4092678e4e78230f46a1534c0fbc8fa39780892b',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'EKO',
    address: '0xa6a840e50bcaa50da017b91a0d86b8b2d41156ee',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'OST',
    address: '0x2c4e8f2d746113d0696ce89b35f0d8bf88e0aeca',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'DTH',
    address: '0x5adc961d6ac3f7062d2ea45fefb8d8167d44b190',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'PT',
    address: '0x094c875704c14783049ddf8136e298b3a099c446',
    swapGasLimit: 380000,
    approveGasLimit: 100000
  },
  {
    symbol: 'INF',
    address: '0x00e150d741eda1d49d341189cae4c08a73a49c95',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'TTC',
    address: '0x9389434852b94bbad4c8afed5b7bdbc5ff0c2275',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'ABYSS',
    address: '0x0e8d6b471e332f140e7d9dbb99e5e3822f728da6',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'WBTC',
    address: '0x2260fac5e5542a773aa44fbcfedf7c193bc2c599',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'MLN',
    address: '0xec67005c4e498ec7f55e092bd1d35cbc47c91892',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'USDC',
    address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'EURS',
    address: '0xdb25f211ab05b1c97d595516f45794528a807ad8',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'BIX',
    address: '0xb3104b4b9da82025e8b9f8fb28b3553ce2f67069',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  },
  {
    symbol: 'CDT',
    address: '0x177d39ac676ed1c67a2b268ad7f1e58826e5b0af',
    swapGasLimit: 330000,
    approveGasLimit: 100000
  }
];
